import React, { useState } from "react";
import { Box, Typography, Grid, Paper, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { convertDateToCustomFormat } from "../../../utils/commonUtils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

// const salesData = [
//   { label: "Total Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Counter Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Credit Sale", today: "0.00", monthly: "0.00" },
//   { label: "Expenses", today: "0.00", monthly: "14000.00" },
//   { label: "Number of Bills", today: "0", monthly: "38" },
//   { label: "Product Sold", today: "0", monthly: "58" },
//   { label: "Service Sold", today: "0", monthly: "26" },
// ];

const TableReport = ({ salesData, colName, data }) => {
  const [selectedIndex, setIndex] = useState(-1)
  return (
    <Box
      sx={{
        py: "20px",
        px: { xs: "10px", sm: "50px" },
        background: "white",
        borderRadius: "10px",
      }}
    >
      <Grid container spacing={1}>
        <Grid
          container
          spacing={1}
          sx={{ borderBottom: "1px solid #1E1E1E", padding: "10px 0px" }}
        >
          <Grid item xs={6}>
            <Typography
              color="primary"
              sx={{
                textAlign: "center",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                fontWeight: 500,
              }}
            >
              Date
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography
              color="primary"
              sx={{
                textAlign: "center",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                fontWeight: 500,
              }}
            >
              Total
            </Typography>
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid>

        {/* Header */}
        <Box
          sx={{
            maxHeight: "50vh",
            overflowY: "auto",
            width: "100%",
            pr: "10px",
          }}
        >
          <Grid container>
            {data.map((item, idx) => (
              <Grid
                item
                xs={12}
                onClick={() => {
                  setIndex(idx);
                }}
                sx={{ margin: "5px 0" }}
              >
                <Accordion
                  expanded={selectedIndex == idx}
                  sx={{
                    borderTopRightRadius: "20px",
                    borderTopLeftRadius: "20px",
                    borderBottomRightRadius: selectedIndex == idx ? "" : "20px",
                    borderBottomLeftRadius: selectedIndex == idx ? "" : "20px",
                    backgroundColor:
                      selectedIndex == idx ? "#01008B" : "#E3E3FF",
                    boxShadow: "none",
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <Box
                        sx={{ color: selectedIndex == idx ? "white" : "black" }}
                      >
                        <ExpandMoreIcon />
                      </Box>
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    // xs={{background:"#01008B"}}

                    sx={{
                      background: "#01008B",
                      borderTopRightRadius: "20px",
                      borderTopLeftRadius: "20px",
                      borderBottomRightRadius:
                        selectedIndex == idx ? "" : "20px",
                      borderBottomLeftRadius:
                        selectedIndex == idx ? "" : "20px",
                      backgroundColor:
                        selectedIndex == idx ? "#01008B" : "#E3E3FF",
                    }}
                  >
                    <Grid container>
                      <Grid item xs={6}>
                        <Typography
                          color="white"
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            overflow: "Hidden",
                            fontWeight: 500,
                            textAlign: "center",

                            color: selectedIndex == idx ? "white" : "black",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {convertDateToCustomFormat(item?.date?.split("T")[0])}
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        xs={1}
                        color={"white"}
                        sx={{
                          color: "#000000",
                          fontWeight: 500,
                          display: "flex",
                          justifyContent: "space-between",
                          fontFamily: "'Montserrat', sans-serif",
                          alignItems: "center",
                          textAlign: "center",
                          paddingLeft: { md: 16, sm: 38, lg: 25, xs:8 },

                          color: selectedIndex == idx ? "white" : "black",
                        }}
                      >
                        {/* {calculateTotalPrice(item?.purchaseDetails)} */}
                        <CurrencyRupeeIcon color="#000000" fontSize="10px" />
                        <Typography
                          color="#000000"
                          sx={{
                            textOverflow: "ellipsis",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },

                            fontWeight: 500,
                            // paddingLeft: "10px",
                            color: selectedIndex == idx ? "white" : "black",
                          }}
                        >
                          {item.amount?.toFixed(2)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      // p:"0px 3px",
                      m: "0px",
                      background: "#E3E3FF",
                      // p: "10px 3px" ,
                      p: "20px",
                    }}
                  >
                    {
                      <Grid
                        container
                        sx={{
                          paddingBottom: "10px",
                        }}
                      >
                        <Grid item xs={3} sx={{}}>
                          <Typography
                            color="primary"
                            sx={{
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              textAlign: "center",
                              // overflow: "Hidden",

                              // textOverflow: "ellipsis",
                              fontFamily: "'Montserrat', sans-serif",
                              fontWeight: 500,
                            }}
                          >
                            Item Description
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          xs={3}
                          color="primary"
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          <Typography
                            color="primary"
                            sx={{
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              overflow: "Hidden",

                              textOverflow: "ellipsis",
                              fontFamily: "'Montserrat', sans-serif",
                              fontWeight: 500,
                            }}
                          >
                            Qty
                          </Typography>
                          {/* <CurrencyRupeeIcon color="primary" fontSize="10px" /> */}
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                          color="primary"
                        >
                          <Typography
                            color="primary"
                            textAlign={"center"}
                            sx={{
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              overflow: "Hidden",

                              textOverflow: "ellipsis",
                              fontFamily: "'Montserrat', sans-serif",
                              fontWeight: 500,
                            }}
                          >
                            Rate (₹)
                          </Typography>
                          {/* <CurrencyRupeeIcon color="primary" fontSize="10px" /> */}
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          color="primary"
                          textAlign={"center"}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            color="primary"
                            textAlign={"center"}
                            sx={{
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              overflow: "Hidden",

                              textOverflow: "ellipsis",
                              fontFamily: "'Montserrat', sans-serif",
                              fontWeight: 500,
                            }}
                          >
                            Total (₹)
                          </Typography>
                          {/* <CurrencyRupeeIcon color="primary" fontSize="10px" /> */}
                        </Grid>
                      </Grid>
                    }

                    {item?.purchaseDetails?.map((item2, index) => {
                      return (
                        <Grid
                          container
                          style={{
                            borderBottom: "1px solid black",
                            marginBottom: "20px",
                          }}
                        >
                          <Grid
                            item
                            xs={3}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              textAlign={"center"}
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                fontWeight: 400,
                                overflow: "Hidden",
                                fontFamily: "'Montserrat', sans-serif",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {item2?.description}
                            </Typography>
                          </Grid>

                          <Grid
                            item
                            xs={3}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },

                              fontFamily: "'Montserrat', sans-serif",
                            }}
                          >
                            {/* <CurrencyRupeeIcon color="primary" fontSize="10px" /> */}
                            {item2?.quantity}
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              alignItems: "center",
                              fontFamily: "'Montserrat', sans-serif",
                            }}
                          >
                            {/* <CurrencyRupeeIcon color="primary" fontSize="10px" /> */}
                            ₹ {item2?.price?.toFixed(2)}
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              fontWeight: 500,
                              fontFamily: "'Montserrat', sans-serif",
                            }}
                          >
                            {/* <CurrencyRupeeIcon color="primary" fontSize="10px" /> */}
                            ₹ {item2?.amount?.toFixed(2)}
                          </Grid>
                        </Grid>
                      );
                    })}
                  </AccordionDetails>
                </Accordion>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};

export default TableReport;
